// Available user modules are documented here:
// https://confluence.nfon.net/display/UCB/User-Modules

export enum UserModule {
  Admin = "admin",
  Phone = "phone",
  Fax = "fax",
  Conference = "conference",
  LiteMode = "litemode",
  Video = "video",
  ScreenShare = "screenshare",
  NConnectVoice = "nconnect_voice",
  VideoConference = "videoconference",
  BulkImport = "bulk-import",
  Meeting = "meeting",
  MeetingOptionPerUser = "meetingoptionperuser",
  MeetingMessages = "meetingmessages",
  CRMConnect = "crmconnect",
  Preview = "preview",
  MobileDebugMode = "mobile_debugmode",
}
